/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Bad Request problems.
 */
export type BadRequestProblems =
    | Truvity.BadRequestProblems.BadRequest
    | Truvity.BadRequestProblems.BadRequestBlobEmptyData
    | Truvity.BadRequestProblems.BadRequestBlobInvalidJson
    | Truvity.BadRequestProblems.BadRequestHasNullUnicodeCharacter
    | Truvity.BadRequestProblems.BadRequestPayloadTooLarge
    | Truvity.BadRequestProblems.BadRequestValidation;

export namespace BadRequestProblems {
    export interface BadRequest extends Truvity.ProblemBadRequest {
        type: '/bad-request';
    }

    export interface BadRequestBlobEmptyData extends Truvity.ProblemBadRequestBlobEmptyData {
        type: '/bad-request/blob-empty-data';
    }

    export interface BadRequestBlobInvalidJson extends Truvity.ProblemBadRequestBlobInvalidJson {
        type: '/bad-request/blob-invalid-json';
    }

    export interface BadRequestHasNullUnicodeCharacter extends Truvity.ProblemBadRequestHasNullUnicodeCharacter {
        type: '/bad-request/has-null-unicode-character';
    }

    export interface BadRequestPayloadTooLarge extends Truvity.ProblemBadRequestPayloadTooLarge {
        type: '/bad-request/payload-too-large';
    }

    export interface BadRequestValidation extends Truvity.ErrorModel {
        type: '/bad-request/validation';
    }
}
